module.exports = __webpack_public_path__ + "static/media/welcomePage.4e0e5efe.png";